<template>
  <div class="bg-white text-neutral-900">
    <div class="mt-5 h-fit relative">
      <div class="max-w-5xl mx-auto py-5">

        <div class="pt-5">
          <label class="input input-bordered flex items-center gap-2 text-neutral-900">
            <input v-model="query" type="text" class="grow" placeholder="Inizia a digitare..."/>
            <span  v-if="query" @click="query = ''" class="btn btn-circle btn-ghost">x</span>
          </label>
        </div>

        <div class="py-8">
          <div v-if="!selectedProduct" class="container text-center">
            <button  v-for="item in products" class="btn btn-error btn-sm rounded-3xl mr-2 mb-2"
                     @click="loadProductResults(item.key)">{{item.key}}</button>
          </div>

          <div v-if="selectedProduct" class="text-left">
            <button class="btn btn-error btn-sm rounded-3xl mr-2 mb-2"
                    @click="loadProductResults(null)">{{selectedProduct}}
              <div class="btn btn-sm btn-circle btn-ghost right-2 top-2">✕</div>
            </button>
          </div>
        </div>

        <div v-if="results.length" class="flex flex-wrap justify-center max-w-5xl mx-auto">
          <ui-onp-card :record="record" v-for="record in results" @record:open="openRecord"/>
          <template-disclaimer/>
        </div>

      </div>
    </div>
  </div>
  <ui-modal ref="dialog" @dismiss="isOpen = false" class="p-0">
    <template #body>
      <NuxtPage/>
    </template>
  </ui-modal>
</template>
<script setup lang="ts">
const showActions = inject('showActions')
// Cambia il valore per questa pagina
showActions.value = false

import type {ONPRecord} from "~/types/record";
import {useProducts} from "~/composables/useProducts";

const {getOnpListFromQuery} = useRecords();
const query = ref('');
const results = ref([]);
const {params} = useRoute();
const {$listen} = useNuxtApp();
const isOpen = ref(false);
const dialog = ref(null);
const selectedProduct = ref(null);
definePageMeta({
  layout: 'dark'
})

const {getProductsList} = useProducts();
const {getOnpListFromKey} = useRecords();

const products = ref({});

const loadProducts = async () => {
  products.value = await  getProductsList();
}
loadProducts();

const loadProductResults = async (key) => {
  selectedProduct.value = key;
  results.value = await getOnpListFromKey('products', key);
}

const search = async () => {
  results.value = await getOnpListFromQuery(query.value,selectedProduct.value);
}

watch(() => query.value, async (value) => {
  if (value.length > 2 || value.length === 0) {
    await search()
  }
}, {deep: true})

onMounted(async () => {
  // Se è presente un id nella route apro il record
  if (params.id) {
    await openRecord({id: params.id});
  }
  await search()
})

const openRecord = async (record: ONPRecord) => {
  isOpen.value = true;
  setTimeout(() => {
    dialog.value?.setOpen(true);
  }, 100);
  await navigateTo({path: `/cerca/record-${record.id}`})

}

</script>